'use client'
import React, { FC } from 'react'
import classNames from 'classnames'
import BitcoinIcon from '@/icons/bitcoin-filled'
import { NETWORK } from '@/utils/constants'
import featureFlags from '@/utils/feature-flags'
import styles from './TopUpNavLink.module.css'
import Link from 'next/link'

const TopUpNavLink: FC<{
	className?: string
	onClick?: () => void
}> = (props) => {
	const { onClick } = props

	if (featureFlags('app::disable_trade')) {
		return <React.Fragment />
	}

	return (
		<Link
			href="/markets/bitcoin"
			onClick={onClick}
			className={classNames(styles.root, {
				[props.className as any]: !!props.className
			})}
		>
			<BitcoinIcon width={16} height={16} className={styles.icon} />
			<span className={classNames(styles.label, 'semibold')}>Buy/Sell {NETWORK}</span>
		</Link>
	)
}

export default TopUpNavLink
